/**
 * The default ID applied to the chatbot <script> tag when injected.
 */
export const CHATBOT_SCRIPT_ID = '__applied-chatbot-script';

/**
 * The CDN URL for the Applied Labs chatbot script.
 */
export const CHATBOT_SCRIPT_SRC = 'https://cdn.applied.guide/artifacts/applied-chat.umd.js';
